<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 选择 -->
    <!-- <div class="top">
        <div
          :class="selectActive == v.id ? 'selectActive' : 'select'"
          v-for="v in select"
          :key="v.id"
          @click="changeSelect(v)"
        >
          {{ v.name }}
        </div>
      </div> -->
    <!-- 表单查询 -->
    <!-- <el-form :inline="true" ref="form" :model="form" label-width="80px">
        <el-form-item label="创建日期">
          <el-date-picker
            v-model="form.startTime"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary">查询</el-button>
          <el-button>重置</el-button>
        </el-form-item>
      </el-form> -->
    <div class="flex aic">
      <btns class="mgb-20" @exec="exec"></btns>
      <div class="colorred mgl-30">
        故障级别分类：A类-致命故障，停止工作，仅保障联网状态，以监控设备；B类-严重故障，禁止取水；C类-普通故障，不影响或限制部分业务
      </div>
    </div>
    <div>
      <!-- 表格 -->
      <el-table :data="tableData" stripe border style="width: 100%">
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="50"
          fixed="left"
        >
        </el-table-column>
        <!-- <el-table-column prop="type" label="设备来源"> </el-table-column> -->
        <el-table-column prop="error" label="故障码" width="180">
        </el-table-column>
        <el-table-column prop="message" label="代表状态"> </el-table-column>
        <el-table-column prop="level" label="故障级别"> </el-table-column>
        <el-table-column prop="action" label="故障关联动作"> </el-table-column>
        <el-table-column prop="solutionNew" label="解决步骤">
          <template slot-scope="scope">
            <span>{{ scope.row.solutionNew }}</span>
            <el-button
              v-if="scope.row.solution.length > 50"
              type="text"
              size="small"
              @click="
                buzhouVisible = true;
                buzhou = scope.row.solution;
              "
              >更多</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="solution" label="技术对接人">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.person"
              type="text"
              size="small"
              @click="handleLook(scope.row)"
              >查看</el-button
            >
            <div v-else>- -</div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建日期"> </el-table-column>
        <!-- <el-table-column
          fixed="right"
          label="操作"
          width="150"
          v-if="roleId == 1"
        >
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-button type="text" size="small" @click="handleDel(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column> -->
      </el-table>
    </div>

    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>

    <!-- 新增编辑弹框 -->
    <el-dialog
      :title="type == 1 ? '新增故障码' : '修改故障码'"
      center
      :visible.sync="dialogVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form
        ref="addForm"
        :rules="rules"
        :model="addForm"
        label-width="120px"
      >
        <!-- <el-form-item label="设备来源" prop="source">
            <el-select
              :disabled="type == 2"
              v-model="addForm.source"
              placeholder="请选择设备来源"
            >
              <el-option
                v-for="v in sourceArr"
                :key="v.dictId"
                :label="v.dictName"
                :value="v.dictName"
              ></el-option>
            </el-select>
          </el-form-item> -->
        <!-- <el-form-item label="机器来源" prop="source">
            <el-input
              v-model="addForm.source"
              placeholder="请输入错误代码"
            ></el-input>
          </el-form-item> -->
        <el-form-item label="故障码" prop="code">
          <el-input
            v-model="addForm.code"
            placeholder="请输入故障码"
          ></el-input>
        </el-form-item>
        <el-form-item label="代表状态" prop="state">
          <el-input
            v-model="addForm.state"
            placeholder="请输入代表状态"
          ></el-input>
        </el-form-item>
        <el-form-item label="故障关联动作" prop="action">
          <el-input
            type="textarea"
            v-model="addForm.action"
            placeholder="请输入故障关联动作"
          ></el-input>
        </el-form-item>
        <el-form-item label="解决步骤" prop="way">
          <el-input
            type="textarea"
            v-model="addForm.way"
            placeholder="请输入解决步骤"
          ></el-input>
        </el-form-item>
        <el-form-item label="故障级别" prop="rank">
          <el-select v-model="addForm.rank" placeholder="请选择故障级别">
            <el-option label="A" value="A"></el-option>
            <el-option label="B" value="B"></el-option>
            <el-option label="C" value="C"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="技术对接人" prop="people">
          <div
            class="flex aic jishuduijie"
            v-for="(v, i) in addForm.people"
            :key="i"
          >
            <el-select
              v-model="v.branch"
              placeholder="请选择部门"
              @change="$forceUpdate()"
            >
              <el-option
                v-for="(v2, i2) in branchArr"
                :key="i2"
                :label="v2.dictName"
                :value="v2.dictName"
              ></el-option>
            </el-select>
            <el-input
              class="mgl-10 mgr-10"
              v-model="v.name"
              placeholder="请输入姓名"
              @input="$forceUpdate()"
            ></el-input>
            <el-input
              v-model="v.phone"
              placeholder="请输入电话"
              @input="$forceUpdate()"
            ></el-input>
            <el-button
              class="mgl-10"
              v-if="i == addForm.people.length - 1"
              @click="addDomain"
              >新增</el-button
            >
            <el-button
              class="mgl-10"
              v-if="i !== 0"
              @click.prevent="removeDomain(v)"
              >删除</el-button
            >
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="dialogVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="sure('addForm')">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 技术对接人弹框 -->
    <el-dialog
      title="技术对接人"
      :visible.sync="dduijieVisible"
      width="35%"
      center
      :close-on-click-modal="true"
      top="30vh"
    >
      <el-table :data="personList" border stripe style="width: 100%">
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="50"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="department" label="部门"> </el-table-column>
        <el-table-column prop="person" label="姓名"> </el-table-column>
        <el-table-column prop="phone" label="电话"> </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dduijieVisible = false">已知晓</el-button>
      </span>
    </el-dialog>

    <!-- 解决步骤弹框 -->
    <el-dialog
      title="解决步骤"
      :visible.sync="buzhouVisible"
      width="35%"
      center
      :close-on-click-modal="true"
      top="30vh"
    >
      <div>{{ buzhou }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="buzhouVisible = false">已知晓</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import btns from "@/components/btns.vue";
import store from "../../store";

import { handleConfirm, handleAlert } from "../../components/UtilsIf";
export default {
  components: {
    breadcrumbs,
    btns,
  },
  data() {
    return {
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return time.getTime() < new Date(beginDateVal).getTime();
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      select: [
        { id: 1, name: "未来先生一" },
        { id: 2, name: "未来先生二" },
      ],
      selectActive: 1,
      form: {},
      tableData: [],
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 20, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      dialogVisible: false,
      addForm: {
        code: "",
        state: "",
        way: "",
        action: "",
        rank: "",
        people: [{ branch: "", name: "", phone: "" }],
      },
      sourceArr: [],
      tableData2: [],
      buzhouVisible: false,
      buzhou: "",
      rules: {
        source: [
          { required: true, message: "请选择设备来源", trigger: "blur" },
        ],
        code: [{ required: true, message: "请输入故障码", trigger: "blur" }],
        state: [{ required: true, message: "请输入代表状态", trigger: "blur" }],
        way: [{ required: true, message: "请输入解决步骤", trigger: "blur" }],
        action: [
          { required: true, message: "请输入故障关联动作", trigger: "blur" },
        ],
        rank: [{ required: true, message: "请选择故障级别", trigger: "blur" }],
        people: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      type: null,
      id: null,
      roleId: null,
      branchArr: [],
      dduijieVisible: false,
      personList: [],
    };
  },
  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    },
  },
  created() {
    this.getsource();
    this.getList();
    this.getROLE();
    this.getBranch();
  },
  methods: {
    handleLook(row) {
      this.personList = JSON.parse(row.person);
      this.dduijieVisible = true;
    },
    getROLE() {
      var token = store.getters.get_token;
      if (token) {
        this.roleId = token.roleId;
      }
    },
    getList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.shebei
        .errorList({
          pageNum: this.page,
          pageSize: this.pageSize,
          type: this.selectActive === 1 ? "未来先生一" : "未来先生二",
        })
        .then((res) => {
          if (res.code === 200) {
            res.data.rows.forEach((v) => {
              if (v.solution.length > 50) {
                v.solutionNew = v.solution.substring(0, 50) + "...";
              } else {
                v.solutionNew = v.solution;
              }
            });
            this.tableData = res.data.rows;
            this.total = res.data.total;
          }
        });
    },
    add() {
      this.type = 1;
      this.dialogVisible = true;
      this.addForm = {
        source: "",
        code: "",
        state: "",
        way: "",
        action: "",
        rank: "",
        people: [{ branch: "", name: "", phone: "" }],
      };
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.addForm.clearValidate();
      });
    },
    handleDel(row) {
      handleConfirm(`确认删除该故障码吗？`, "info")
        .then(() => {
          this.$api.shebei.errorDel({ id: row.id }).then((res) => {
            if (res.code === 200) {
              handleAlert("删除成功", "success");
              this.getList();
            }
          });
        })
        .catch(() => {
          return;
        });
    },
    addDomain() {
      this.addForm.people.push({
        branch: "",
        name: "",
        phone: "",
        key: Date.now(),
      });
      this.$forceUpdate();
    },
    removeDomain(item) {
      var index = this.addForm.people.indexOf(item);
      if (index !== -1) {
        this.addForm.people.splice(index, 1);
        this.$forceUpdate();
      }
    },
    handleEdit(row) {
      this.dialogVisible = true;
      this.type = 2;

      this.addForm = {
        source: row.type,
        code: row.error,
        state: row.message,
        way: row.solution,
        rank: row.level,
        action: row.action,
      };
      let arr = [];
      if (row.person) {
        arr = JSON.parse(row.person);
        this.addForm.people = [];
        arr.forEach((v) => {
          this.addForm.people.push({
            branch: v.department,
            name: v.person,
            phone: v.phone,
          });
        });
      } else {
        this.addForm.people = [{ branch: "", name: "", phone: "" }];
      }

      this.id = row.id;
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.addForm.clearValidate();
      });
    },
    getsource() {
      this.$api.dict.list({ dictName: "机器来源" }).then((res) => {
        if (res.code === 200) {
          const arr = res.data;
          this.sourceArr = [];
          arr.forEach((v) => {
            if (v.dictPid !== 0 && v.dictName !== "未来先生") {
              this.sourceArr.push(v);
            }
          });
        }
      });
    },
    getBranch() {
      this.$api.dict.list({ dictName: "公司部门" }).then((res) => {
        if (res.code === 200) {
          const arr = res.data;
          this.branchArr = [];
          arr.forEach((v) => {
            if (v.dictPid !== 0 && v.dictName !== "公司部门") {
              this.branchArr.push(v);
            }
          });
        }
      });
    },
    sure(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          let str = 1;
          this.addForm.people.forEach((v) => {
            if (v.branch == "" || v.name == "" || v.phone == "") {
              str = 0;
            }
          });
          if (str == 0) {
            handleAlert("请输入完整的技术对接人", "error");
            return;
          }
          let arr = [];
          this.addForm.people.forEach((v) => {
            arr.push({
              department: v.branch,
              person: v.name,
              phone: v.phone,
            });
          });
          if (this.type === 1) {
            handleConfirm(`确认新增该故障吗？`, "info")
              .then(() => {
                this.$api.shebei
                  .errorAdd({
                    error: this.addForm.code,
                    message: this.addForm.state,
                    solution: this.addForm.way,
                    type: "未来先生一",
                    action: this.addForm.action,
                    level: this.addForm.rank,
                    personList: arr,
                  })
                  .then((d) => {
                    if (d.code === 200) {
                      this.dialogVisible = false;
                      handleAlert("新增成功", "success");
                      this.getList();
                    }
                  });
              })
              .catch(() => {
                return;
              });
          } else {
            handleConfirm(`确认修改该故障码吗？`, "info")
              .then(() => {
                this.$api.shebei
                  .errorEdit({
                    id: this.id,
                    error: this.addForm.code,
                    message: this.addForm.state,
                    solution: this.addForm.way,
                    type: "未来先生一",
                    action: this.addForm.action,
                    level: this.addForm.rank,
                    personList: arr,
                  })
                  .then((d) => {
                    if (d.code === 200) {
                      this.dialogVisible = false;
                      handleAlert("修改成功", "success");
                      this.getList();
                    }
                  });
              })
              .catch(() => {
                return;
              });
          }
        } else {
          return false;
        }
      });
    },
    changeSelect(v) {
      this.selectActive = v.id;
      this.getList();
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    //表格序号，根据索引+1
    indexMethod2(index) {
      return index + 1;
    },
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getList(this.page);
    },
  },
};
</script>

<style lang="scss" scoped>
.top {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  .select {
    width: 300px;
    height: 35px;
    text-align: center;
    line-height: 35px;
    margin-right: 50px;
    box-sizing: border-box;
    background: var(--card-bg);
    cursor: pointer;
  }
  .selectActive {
    width: 300px;
    height: 35px;
    text-align: center;
    line-height: 35px;
    margin-right: 50px;
    box-sizing: border-box;
    background: var(--accent);
    cursor: pointer;
    color: #fff;
  }
}
/deep/ .el-textarea__inner {
  height: 120px;
}
.jishuduijie:nth-child(1) {
  margin-top: 0px;
}
.jishuduijie {
  margin-top: 10px;
}
</style>
